import { REGULAR_DATE_FORMAT } from '@/const';
import { format } from 'date-fns';
import React from 'react';

export const LAST_VERIFIED_TEST_ID = 'last_verified';
interface AssetLastVerifiedProps {
  lastVerified: string;
}

export const AssetLastVerified = ({ lastVerified }: AssetLastVerifiedProps) => {
  return (
    <span
      className="text-xs font-medium text-[#55687D] h-4 flex items-center py-2.5"
      data-testid={LAST_VERIFIED_TEST_ID}
    >
      {`Last verified: ${lastVerified ? format(new Date(lastVerified), REGULAR_DATE_FORMAT) : 'N/A'}`}
    </span>
  );
};
